import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectors as apiSelectors } from 'zender-api-client';

import TotalPlayers from './TotalPlayers.component';
import * as appSelectors from '../../../../../selectors';

const TotalPlayersContainer = props => <TotalPlayers {...props} />;

const mapStateToProps = state => ({
	userCount: apiSelectors.stream.userCountSelector(state),
	inTheRunningCount: apiSelectors.quiz.latestQuizUsersInTheRunningSelector(state),
	locale: appSelectors.locale.localeSelector(state),
});

const mapDispatchToProps = () => ({});

TotalPlayersContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TotalPlayersContainer);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/totalPlayers/TotalPlayers.container.js